export const TRUST_TYPES = {
  IrrevocableTrust: 'Irrevocable Trust',
  RevocableTrust: 'Revocable Trust'
} as const;

export const TRUST_MEMBER_TYPES = {
  Trustee: 'Trustee',
  TrustProtector: 'Trust Protector',
  DistributionTrustee: 'Distribution Trustee'
} as const;

export type TrustType = typeof TRUST_TYPES[keyof typeof TRUST_TYPES];
export type TrustMemberType = typeof TRUST_MEMBER_TYPES[keyof typeof TRUST_MEMBER_TYPES];
